import { useContextConsumer } from "modules/context/Providers/ContextProvider";
import { LoggingMode } from "modules/context/types/LoggingMode";

export const useIsSsoAuthenticationAllowed = () => {
  const { loggingInMode } = useContextConsumer();

  return !!loggingInMode.find((mode) => mode === LoggingMode.Sso);
};

